import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  id: "spotlight",
  class: "flexcol"
}
const _hoisted_2 = { id: "results_list" }

import SearchHeader from "@/components/SearchForm/SearchHeader.vue";
import { isValidQuery, handleSearch } from "@/busData";

import "normalize.css"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(SearchHeader, {
      onSearch: _unref(handleSearch),
      onHandleChange: _cache[0] || (_cache[0] = ($event: any) => (isValidQuery.value = true))
    }, null, 8, ["onSearch"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock("div", {
                class: "flex wrap router-view",
                key: Component
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ]))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})